import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalTDelete(props) {
    const {
        techModalDeleteString,
        techMDNameString,
        techMDEmailString,
        techMDPhoneString,
        techMDEDateString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteTechName = localStorage.getItem("techNameToDelete");
    var deleteTechEmail = localStorage.getItem("techEmailToDelete");
    var deleteTechCreatedDate = localStorage.getItem("techCreatedDateToDelete");
    var deleteTechPhone = localStorage.getItem("techPhoneToDelete");

    var deleteTechId = localStorage.getItem("techIdToDelete");

    function deleteTech() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteTech/${deleteTechId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar técnico. Vuelve a intentarlo.' });
        });
    };
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Técnico eliminado exitosamente en la base de datos.' });
        props.getTechs();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {techModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{techMDNameString}:</strong> {deleteTechName}</span><br />
                <span className='delete-info'><strong>{techMDEmailString}:</strong> {deleteTechEmail}</span><br />
                <span className='delete-info'><strong>{techMDPhoneString}:</strong> {deleteTechPhone}</span><br />
                <span className='delete-info'><strong>{techMDEDateString}:</strong> {deleteTechCreatedDate}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteTech()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalTDelete;